<template>
  <nav class="bottom-nav">
    <router-link
      v-for="item in items"
      :key="item.to"
      :to="item.to"
      :class="['nav-item', { active: isActive(item.to) }]"
    >
      <span class="material-symbols-rounded nav-icon">{{ item.icon }}</span>
      <span>{{ item.label }}</span>
    </router-link>
  </nav>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()

const items = [
  { to: "/dashboard", label: "Home",      icon: "home" },
  { to: "/tasks",     label: "Tasks",     icon: "checklist" },
  { to: "/projects",  label: "Projects",  icon: "folder_open" },
  { to: "/events",    label: "Calendar",  icon: "calendar_month" },
  { to: "/habits",    label: "Trackers",  icon: "self_improvement" },
  { to: "/reminders", label: "Reminders", icon: "notifications_active" },
]

const isActive = computed(() => (to: string) => route.path === to || route.path.startsWith(`${to}/`))
</script>
